import { hydrateRoot } from "react-dom/client";
import App from "./frontend/App";
import ClientApp from "./ClientApp"

//@ts-ignore
const hydrationData = window.__staticRouterHydrationData;

hydrateRoot(document.body, <ClientApp hydrationData={hydrationData} />)